import React from 'react';

const JobTaskDetails: React.FC = () => {
    return <div className="job-task-details">

    </div>;
}

export default JobTaskDetails;